var map = {
	"./apple-logo.svg": 6754,
	"./calendar-minus.svg": 1830,
	"./calendar-plus.svg": 5803,
	"./check-circle.svg": 3881,
	"./check-verified.svg": 2338,
	"./chevron-left.svg": 5742,
	"./clock.svg": 7947,
	"./google-logo.svg": 5959,
	"./mail.svg": 2059,
	"./menu.svg": 3898,
	"./microsoft-logo.svg": 3507,
	"./passcode-lock.svg": 28,
	"./phone.svg": 6289,
	"./ratings/bad.svg": 319,
	"./ratings/good.svg": 9368,
	"./ratings/great.svg": 2342,
	"./ratings/horrible.svg": 9617,
	"./ratings/super.svg": 4970,
	"./refresh.svg": 1431,
	"./star.svg": 6380,
	"./stars.svg": 6911,
	"./summary.svg": 6737,
	"./times-icon.svg": 3565,
	"./user-circle.svg": 5308,
	"./x-circle-solid.svg": 4551,
	"./x-circle.svg": 8114,
	"./x-close.svg": 5062,
	"./x-solid.svg": 8803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;